import type { MouseEvent } from 'react';

import { useRouter } from 'next/router';

import Link from '~/src/common/components/Link';
import Sticker from '~/src/common/components/Sticker';

import { useNavigationTracking } from '../tracking';
import type * as T from '../types';

import styles from './SubCategories.module.scss';

interface Props {
  category: T.Category;
  subcat: T.SubCategory;
}

const SubCategory = ({ category, subcat }: Props) => {
  const { push } = useRouter();
  const { onClickSubCategoryName } = useNavigationTracking().large;

  // Interception du click pour redirection
  const handleClick = (event: MouseEvent) => {
    event.preventDefault();
    onClickSubCategoryName(subcat.id);
    void push(`/categorie/${category.slug}#${subcat.id}`);
  };

  return (
    <li className={styles.item}>
      <Link href={`/categorie/${subcat.slug}`} onClick={handleClick}>
        {subcat.name}
      </Link>
      {subcat.label && (
        <Sticker bg={subcat.label.bg} fg={subcat.label.fg}>
          {subcat.label.text}
        </Sticker>
      )}
    </li>
  );
};

export default SubCategory;
